import { render, staticRenderFns } from "./AgreementsVstTablePage.vue?vue&type=template&id=c541243a"
import script from "./AgreementsVstTablePage.vue?vue&type=script&lang=js"
export * from "./AgreementsVstTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports